import React from "react";

function Footer() {
    return (
        <div>
            <footer className="footer"> Made with &hearts; by Rishab </footer>
        </div>
    );    
}

export default Footer;